/** Features computed on the RAF-driven FFT bus, once per ten animation frames (~167 ms). */
export const fftDSPFeatures = ['chroma', 'chord', 'rms', 'tuner', 'fft'] as const

/**
 * Features that run in their own AudioWorklet, on the audio thread, at their own hop.
 *
 * `pitch` is here because the FFT bus delivers 2-3 frames per sung note, and note segmentation,
 * onset detection and a median-based per-note pitch all need >= 15.
 * @see docs/superpowers/specs/2026-09-06-vocal-pitch-training-design.md §3.2
 */
export const workletDSPFeatures = ['pitch'] as const

export const dspFeatures = [...fftDSPFeatures, ...workletDSPFeatures] as const

export type FFTDSPFeatureName = (typeof fftDSPFeatures)[number]
export type DSPFeatureName = (typeof dspFeatures)[number]
// @note we also dispatch a 'all' feature that has all the features
export type DSPAllFeatureName = 'all'

export type DSPFeatureNameWithAll = DSPFeatureName | DSPAllFeatureName
